import { yupResolver } from '@hookform/resolvers/yup';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Checkbox, Container, Grid, Popover, TextField, Typography } from '@mui/material';
import { PDFExport } from "@progress/kendo-react-pdf";
import axios from 'axios';
import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { skillLevels } from 'src/assets/data/Dummy';
import DekstopPoup from 'src/components/CareerDetailsPopup/DekstopPoup';
import MobilePopup from 'src/components/CareerDetailsPopup/MobilePopup';
import CompareCareerComponent from 'src/components/CompareCareer';
import GraphsData from 'src/components/GraphsData';
import Report from 'src/components/HTMLtoPdf/Report';
import RadarChartComponent from 'src/components/RadarChart/RadarChartComponent';
import RegionStepper from 'src/components/RegionStepper';
import SecondRegionStepper from 'src/components/stepper/SecondRegionStepper';
import ThinkSkillsHeader from 'src/components/ThinkSkillsHeader';
import { addCompareCareer, setAlert, useGetRegionBySlugQuery, usePostPdfMutation } from 'src/layouts/main/MainLayoutSlice';
import { getRegionBySlug } from 'src/pages/CareerHistory/CareerHistorySlice';
import { ArcticonsEmojiSpiderWeb } from 'src/pages/Reskill_Flow/SpiderIcon';
import { analytics, currencyFormat, exportPDFWithMethod } from 'src/utils';
import { useGetCareersReskillTimeRegionMutation } from 'src/pages/Reskill_Flow/ReskillSlice';
import * as Yup from 'yup';
import { addSkillReport, useCareerNCoursesDetailsMutation, useGetCareersUpskillTimeMutation, useGetCompareCareersDataMutation, useGetSkillsReportDataMutation } from '../UpskillSlice';


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function CareerCoursesUpskillRegion() {
    const dispatch = useDispatch();
    const reportRef = useRef(null);
    const chartRef = useRef(null);
    const popupRef = useRef(null);
    const scrollRef = useRef(null)
    const ref = useRef(null);
    const pdfReportData = useSelector(state => state.upskill.SkillsReport)
    const [compareCareersState, setCompareCareersState] = useState([]);
    const [openCompareCareersPopup, setOpenCompareCareersPopup] = useState(false);
    const [anchorElCareerDetails, setAnchorElCareerDetails] = useState(null);
    const [anchorElChartData, setAnchorElChartData] = useState(null);
    const [openCareerDetailsPopup, setOpenCareerDetailsPopup] = useState(false);
    const [listFilterValue, setListFilterValue] = useState();
    const [chartSize, setChartSize] = useState();
    const [isReskill, setIsReskill] = useState(false);
    const [IP, setIp] = useState("");
    const [expanded, setExpanded] = useState(0);
    const [bubblechartData, setBubblechartData] = useState();
    const [onClickChartData, setOnClickChartData] = useState();
    const [careerGoalId, setCareerGoalId] = useState('');
    const [careerHistoryId, setCareerHistoryId] = useState();
    const [careersUpskillTime, setCareersUpskillTime] = useState();
    const CareerHistoryState = useSelector(state => state.careerHistory.CareerHistory);
    const collegeDetails = useSelector(state => state.mainLayout)
    const CareerGoalState = useSelector(state => state.careerHistory.CareerGoal);
    const collegeId = useSelector(state => state.mainLayout.collegeDetails?._id);
    const [getCompareCareersData] = useGetCompareCareersDataMutation();
    const [getSkillPopupLocation, setGetSkillPopupLocation] = useState();
    const [getCareersUpskillTime, status] = useGetCareersUpskillTimeMutation();
    const [careerNCoursesDetails] = useCareerNCoursesDetailsMutation({});
    const [getCareersReskillTimeRegion, regionStatus] = useGetCareersReskillTimeRegionMutation();
    const [sendSkillReport] = useGetSkillsReportDataMutation({});
    const [careerNCourseData, setCareerNCourseData] = useState();
    const [careerNCoursesPopDetails, setCareerNCoursesPopDetails] = useState();
    const [currentNGoalCareerId, setCurrentNGoalCareerId] = useState();
    const [skillReportDetails, setSkillReportDetails] = useState(null);
    const [careerChartNListData, setcareerChartNListData] = useState();
    const [regionalChartData, setRegionalChartData] = useState({})
    const [qualificationsChartData, setQualificationsChartData] = useState({})
    const [chartWidth, setChartWidth] = useState();
    const [careersListData, setCareersListData] = useState();
    const [UpskillCareerCoursesSteps, setUpskillCareerCoursesSteps] = useState();
    const [value, setChangeValue] = useState(0);
    const [skillRadarPopup, setSkillRadarPopup] = useState(false);
    const [getSkillReportPopup, setGetSkillReportPopup] = useState(false);
    const [termsAndCondition, setTermsAndCondition] = useState(false);
    const [popupChartWidth, setPopupChartWidth] = useState('100%');
    const [compareCareersData, setCompareCareersData] = useState();
    const [report, setReport] = useState({})
    const [readMore, setReadMore] = useState(false)
    const [showCompare, setShowCompare] = useState(false)
    const [pdfLoading, setPdfLoading] = useState(false)
    const navigate = useNavigate();
    const params = useParams();
    const { cg_name, rg_name } = useParams();
    const {
        data: clgByRegion,
        error: regionError,
        isLoading: regionLoading,
    } = useGetRegionBySlugQuery(rg_name, { skip: !rg_name, refetchOnMountOrArgChange: true, });
    const isLoading = regionLoading;
    const errorss = regionError;
    const [uploadPdf, pdfStatus] = usePostPdfMutation();
    const [campusArray, SetCampusArray] = useState([
        'Campus 1', 'Campus 2', 'Campus 3'
    ])
    const darkBlue = "#000c3b"
    const compareCareers = useSelector(state => state.mainLayout.compareCareers)
    const getIp = async () => {
        const res = await axios.get("https://api.ipify.org/?format=json");
        const Ip = res.data.ip
        setIp(Ip)
    }
    useEffect(() => {
        getIp()
    }, [])
    const schema = Yup.object().shape({
        firstName: Yup.string().required(`First name is required`),
        lastName: Yup.string().required(`Last name is required`),
        email: Yup.string().required(`Email is required`).email('Email must be a valid email').matches(/^(?!.*@[^,]*,)/),
    });
    useEffect(() => {
        setCompareCareersState(compareCareers)
    }, [compareCareers])
    useEffect(() => {
        if (skillReportDetails !== null) {
            exportPDFWithMethod(postPdf)
        }
    }, [skillReportDetails]) // eslint-disable-line react-hooks/exhaustive-deps


    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        getValues,
        watch,
        setValue,
    } = useForm({
        resolver: yupResolver(schema),
    });
    useEffect(() => {
        let data
        // console.log('get', getValues())
    }, [watch('email'), watch('firstName'), watch('lastName')]) // eslint-disable-line react-hooks/exhaustive-deps

    const chartDataDetails1 = {
        series: [],
        options: {
            chart: {
                type: 'bar',
                height: 350
            },
            plotOptions: {
                bar: {
                    columnWidth: '70%',
                },
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                labels: {
                    show: false,
                },
            },
            colors: [`${collegeDetails.collegeDetails.primaryColor}`],
            yaxis: {
                min: 0,
                // max: 30000,
            },
        }
    }
    const chartDataDetails2 = {
        series: [],
        options: {
            chart: {
                type: 'bar',
                height: 350
            },
            plotOptions: {
                bar: {
                    columnWidth: '70%',
                },
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                labels: {
                    show: false,
                },
            },
            colors: [`${collegeDetails.collegeDetails.primaryColor}`],
            yaxis: {
                min: 0,
            },
        }
    }

    const handleChange = (e) => (event, isExpanded) => {
        setExpanded(isExpanded ? e : false);
    };

    const handleChangeTab = (event, newValue) => {
        setChangeValue(newValue);
    };
    const clgDetails = useSelector((state) => state.mainLayout.collegeDetails);

    const showCompareCareersPopup = (event) => {
        // if (compareCareersState.length > 0) {
        const apiData = isRegion ? {
            "regionId": clgByRegion?.data?._id,
            "careerRegionId": clgByRegion?.data?._id,
            "currentCareerIds": careerHistoryId,
            "careerGoal": careerGoalId,
            "compareCareerIds": compareCareersState,
            isRegion
        } : {
            "collegeId": collegeId,
            "currentCareerIds": careerHistoryId,
            "careerRegionId": clgDetails?.region?._id,
            "careerGoal": careerGoalId,
            "compareCareerIds": compareCareersState,
            isRegion
        }
        getCompareCareersData(apiData)
            .unwrap()
            .then((payload) => setCompareCareersData(payload))
            .catch((error) => dispatch(setAlert({
                open: true,
                msg: error.data?.msg ? `${error.status}, ${error.data.msg}` : 'Something went wrong'
            })))
        setOpenCompareCareersPopup(true);
        // }
    };
    const showChartDataPopup = (event) => {
        setAnchorElChartData(true);
    }
    const HandleCloseCompareCareersPopup = () => {
        setOpenCompareCareersPopup(false);
        setCompareCareersData('');
        setShowCompare(false)
    };
    const HandleOpenCareerDetailsPopup = (id) => {
        setOpenCompareCareersPopup(false);
        setOpenCareerDetailsPopup(true);
        setCompareCareersData('');
        const data = isRegion ? {
            "regionId": clgByRegion?.data?._id,
            "selectedCareerId": id,
            "currentCareerIds": careerHistoryId,
            isRegion
        } : {
            IP,
            "collegeId": collegeId,
            "selectedCareerId": id,
            "currentCareerIds": careerHistoryId,
            isRegion
        }
        careerNCoursesDetails(data)
            .unwrap()
            .then((payload) => {
                setCareerNCourseData(payload)
            })
            .catch((error) => {
                dispatch(setAlert({
                    open: true,
                    msg: error.data?.msg ? `${error.status}, ${error.data.msg}` : 'Something went wrong'
                }))
                if (error === 500) {
                    setAnchorElCareerDetails(null);
                }
            })
    };

    const HandleCloseCareerDetailsPopup = () => {
        setOpenCareerDetailsPopup(false);
        setCareerNCoursesPopDetails(null)
        setExpanded(0);
        setReadMore(false);
    };
    const openChartDataPopup = Boolean(anchorElChartData);

    const downloadHandler = (page) => {
        // analytics({
        //     collegeId: params?.cg_name,
        //     event: 'SKILL_REPORT',
        //     from: typeof page === 'string' ?  page : 'career-courses',
        //   })
        // if (reportRef.current) {
        // reportRef.current.save();
        // }
    }
    const getSkillsReport = (page) => {
        // if (compareCareersState && compareCareersState.length) {
        //     setGetSkillReportPopup(true)
        // } else {
        //     setGetSkillReportPopup(false)
        // }
        setGetSkillPopupLocation(page);
        setGetSkillReportPopup(true)

    }

    const addToCompare = (data) => {
        if (compareCareers.every(currentCareer => currentCareer !== data)) {
            let careerLimit
            if (careersUpskillTime?.sectorOrSubsector?.some(sector => sector.careers.some(career => career.careerType === 'CAREER_GOAL'))) {
                // careerLimit = 2
                careerLimit = 4
            } else {
                // careerLimit = 3
                careerLimit = 4
            }
            if (compareCareers?.length > careerLimit) {
                if (compareCareers.some(currentCareer => currentCareer !== data)) {
                    dispatch(setAlert({
                        open: true,
                        // msg: `You can't add more than ${careerLimit + 1} careers for comparison`
                        msg: `You have the maximum of ${careerLimit + 2} careers selected for comparison.  Please deselect careers to change your selection.`
                    }))
                }
            } else {
                dispatch(addCompareCareer(data))
                analytics({
                    collegeId,
                    // event: 'SELECTED_CAREER',
                    event: 'CAREER_COMPARISON',
                    from: 'career-courses',
                    data: {
                        // selectedCareerId : data
                        careerComparisonId: data
                    }
                })
            }
        } else {
            dispatch(addCompareCareer(data))
        }
    }

    const removeFromComparison = (id) => {
        dispatch(addCompareCareer(id))
        setCompareCareersState(compareCareersState.filter(career => career !== id))

    }

    const handleFilterChange = (e) => {
        setListFilterValue(e);
        if (e.value === 1) {
            setCareersListData(careersListData.sort((a, b) => b.avgSalary - a.avgSalary))
        }
        else if (e.value === 2) {
            setCareersListData(careersListData.sort((a, b) => b.noOfCourse - a.noOfCourse))
        }
        else if (e.value === 3) {
            setCareersListData(careersListData.sort((a, b) => a.transferWindow - b.transferWindow))
        }
    }

    useEffect(() => {
        if (CareerGoalState) {
            setCareerGoalId(CareerGoalState.value ? CareerGoalState.value : '');
        }
    }, [CareerGoalState]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (CareerHistoryState && CareerHistoryState.length > 0) {
            const id = CareerHistoryState?.map((item) => item?.value || '');
            setCareerHistoryId(id);
        } else {
            navigate(`/region/${params.rg_name}/career-history`);
            dispatch(setAlert({
                open: true,
                msg: 'Please select your current career again'
            }))
        }
    }, [CareerHistoryState]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (ref.current) {
            setChartWidth(ref.current.offsetWidth);
        }
    }, [ref.current]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleWindowResize = () => {
            setChartSize(chartRef?.current?.offsetWidth);
            setChartWidth(ref?.current?.offsetWidth);
            // setPopupChartWidth(popupRef?.current?.offsetWidth);
        };

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    useEffect(() => {
        if (chartRef.current) {
            setChartSize(chartRef.current.offsetWidth);
        }
    }, [chartRef.current]); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //     if (popupRef.current) {
    //         setPopupChartWidth(popupRef.current.offsetWidth);
    //     }
    // }, [popupRef.current]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (careerNCourseData) {
            let newState;
            if (compareCareersState?.length > 0) {
                const isIdInArray = compareCareersState.includes(careerNCourseData.id);
                if (isIdInArray) {
                    newState = {
                        ...careerNCourseData,
                        addToComparison: true
                    };
                } else {
                    newState = {
                        ...careerNCourseData,
                        addToComparison: false
                    };
                }

            }
            else {
                newState = {
                    ...careerNCourseData,
                    addToComparison: false
                };
            }
            setCareerNCoursesPopDetails(newState);
            // if(newState?.courses?.length){
            //     setExpanded(newState?.courses[0].title)
            // }
        }
    }, [careerNCourseData]) // eslint-disable-line react-hooks/exhaustive-deps
    const isRegion = !!params?.rg_name;
    useEffect(() => {
        if (careerGoalId && careerHistoryId && collegeId) {
            const data = {
                "collegeId": collegeId,
                "currentCareerIds": careerHistoryId,
                "careerGoal": careerGoalId,
                isRegion
            }
            if (clgByRegion?.data?._id) {
                data.regionId = clgByRegion?.data?._id;
            }
            if (isReskill) {
                getCareersReskillTimeRegion(data)
                    .unwrap()
                    .then((response) => setCareersUpskillTime(response))
                    .catch((error) => dispatch(setAlert({
                        open: true,
                        msg: error.data?.msg ? `${error.status}, ${error.data.msg}` : 'Something went wrong'
                    })));
            } else {
                getCareersUpskillTime(data)
                    .unwrap()
                    .then((payload) => setCareersUpskillTime(payload))
                    .catch((error) => dispatch(setAlert({
                        open: true,
                        msg: error.data?.msg ? `${error.status}, ${error.data.msg}` : 'Something went wrong'
                    })))
            }
        }
        else if (!careerGoalId && careerHistoryId && collegeId) {
            const data = {
                "collegeId": collegeId,
                "currentCareerIds": careerHistoryId,
                "careerGoal": careerGoalId,
                isRegion
            }
            if (clgByRegion?.data?._id) {
                data.regionId = clgByRegion?.data?._id;
            }
            if (isReskill) {
                getCareersReskillTimeRegion(data)
                    .unwrap()
                    .then((response) => setCareersUpskillTime(response))
                    .catch((error) => dispatch(setAlert({
                        open: true,
                        msg: error.data?.msg ? `${error.status}, ${error.data.msg}` : 'Something went wrong'
                    })));
            } else {
                getCareersUpskillTime(data)
                    .unwrap()
                    .then((payload) => setCareersUpskillTime(payload))
                    .catch((error) => dispatch(setAlert({
                        open: true,
                        msg: JSON.stringify(error)
                    })))
            }
        }
    }, [careerGoalId, careerHistoryId, collegeId, isReskill]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const Qualification = careerNCoursesPopDetails?.growthData?.QualificationGrowth?.chartData?.xaxis
        const Regional = careerNCoursesPopDetails?.growthData?.regionalGrowth?.chartData?.xaxis

        if (careerNCoursesPopDetails && careerNCoursesPopDetails.growthData) {
            // Format regional chart data series to 2 decimal places
            const formattedRegionalSeries = careerNCoursesPopDetails?.growthData?.regionalGrowth?.chartData?.series?.map(series => ({
                ...series,
                data: series.data?.map(dataValue => Number(dataValue).toFixed(2))
            }));
            
            chartDataDetails1.series = formattedRegionalSeries
            chartDataDetails1.options.xaxis = { ...Regional, convertedCatToNumeric: false }
            setRegionalChartData(chartDataDetails1)

            // Format qualifications chart data series to 2 decimal places
            const formattedQualificationSeries = careerNCoursesPopDetails?.growthData?.QualificationGrowth?.chartData?.series?.map(series => ({
                ...series,
                data: series.data?.map(dataValue => Number(dataValue).toFixed(2))
            }));
            
            chartDataDetails2.series = formattedQualificationSeries
            chartDataDetails2.options.xaxis = { ...Qualification, convertedCatToNumeric: false }
            setQualificationsChartData(chartDataDetails2)
        }
    }, [careerNCoursesPopDetails]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (careersUpskillTime?.sectorOrSubsector?.length > 0) {
            const currentNGoalState = {
                currentRoleId: '',
                careerGoalId: ''
            };
            careersUpskillTime?.sectorOrSubsector?.map(sector => {
                if (sector?.careers?.length > 0) {
                    sector?.careers?.map((item) => {
                        if (item.careerType === 'CURRENT_ROLE') {
                            currentNGoalState.currentRoleId = item?.id;
                        }
                        else if (item.careerType === 'CAREER_GOAL') {
                            currentNGoalState.careerGoalId = item?.id;
                        }
                        return ''
                    })
                }
                return ''
            })

            setCurrentNGoalCareerId(currentNGoalState);
        }
    }, [careersUpskillTime])

    useEffect(() => {
        if (careerChartNListData) {
            const data = {
                series: careerChartNListData,
                options: {
                    xaxis: {
                        tickAmount: 20,
                        type: 'category',
                        min: 3,
                        max: 60,
                        title: {
                            text: 'Transfer Window',
                            style: {
                                color: '#1f1f1f',
                                fontSize: '16px',
                                fontFamily: 'Public Sans,sans-serif'
                            },
                        },
                        subTitle: {
                            text: 'Average Salary',
                            style: {
                                color: '#1f1f1f',
                                fontSize: '16px',
                                fontFamily: 'Public Sans,sans-serif'
                            },
                        }
                    },
                    yaxis: {
                        tickAmount: 20,
                        max: 30000,
                        min: 15000,
                        title: {
                            text: 'Average Salary',
                            style: {
                                color: '#1f1f1f',
                                fontSize: '16px',
                                fontFamily: 'Public Sans,sans-serif'
                            },
                        }
                    },
                    stroke: {
                        show: true,
                        curve: 'smooth',
                        colors: ['#fff'],
                        width: 3,
                        dashArray: 0,
                    },
                    fill: {
                        opacity: 0.6
                    },
                    dataLabels: {
                        enabled: false
                    },
                    legend: {
                        position: 'right',
                        horizontalAlign: 'center',
                        offsetX: -40,
                        offsetY: 120,
                        width: 320
                    },
                    tooltip: {
                        enabled: false,
                    },
                    chart: {
                        events: {
                            dataPointSelection(event, chartContext, config) {
                                let chartDetails = {};
                                chartDetails = {
                                    id: config?.w.config.series[config?.seriesIndex]?.careers[config?.dataPointIndex].id,
                                    title: config?.w.config.series[config?.seriesIndex].name,
                                    courses: config?.w.config.series[config?.seriesIndex]?.careers[config?.dataPointIndex].noOfCourse,
                                    duration: config?.w.config.series[config?.seriesIndex]?.careers[config?.dataPointIndex].transferWindow,
                                    avgSalary: currencyFormat(config?.w.config.series[config?.seriesIndex]?.data[config?.dataPointIndex][1]).toString(),
                                    careerName: config?.w.config.series[config?.seriesIndex]?.careers[config?.dataPointIndex].name,
                                    popoverPosition: {
                                        offsetX: event.offsetX,
                                        offsetY: event.offsetY,
                                    },
                                    careerType: config?.w.config.series[config?.seriesIndex].careerType,
                                    addToComparison: config?.w.config.series[config?.seriesIndex]?.careers[config?.dataPointIndex].addToComparison
                                }
                                careerChartNListData?.map((state) => {
                                    state.careers.map((career) => {
                                        if (chartDetails?.id === career.id) {
                                            chartDetails.addToComparison = career.addToComparison
                                        }
                                        return ''
                                    })
                                    return ''
                                })
                                setOnClickChartData(chartDetails);
                            }
                        }
                    }

                }
            }
            setBubblechartData(data);
            const careerDataList = [];

            for (let i = 0; i < careerChartNListData?.length; i += 1) {
                for (let j = 0; j < careerChartNListData[i].careers?.length; j += 1) {
                    careerDataList.push({
                        name: careerChartNListData[i].name,
                        careerType: careerChartNListData[i].careerType,
                        color: careerChartNListData[i].color,
                        id: careerChartNListData[i].careers[j].id,
                        careerName: careerChartNListData[i].careers[j].name,
                        noOfCourse: careerChartNListData[i].careers[j].noOfCourse,
                        transferWindowRange: careerChartNListData[i].careers[j].transferWindow,
                        transferWindow: careerChartNListData[i].data[j][0],
                        avgSalary: careerChartNListData[i].data[j][1],
                        addToComparison: careerChartNListData[i].careers[j].addToComparison
                    })
                }
            }
            if (onClickChartData) {
                const newChartData = onClickChartData;
                careerChartNListData.map((item) => {
                    item.careers.map((career) => {
                        if (career.id === newChartData.id) {
                            newChartData.addToComparison = career.addToComparison
                        }
                        return ''
                    })
                    return ''
                })
                setOnClickChartData(newChartData);
            }
            setCareersListData(careerDataList);
        }
    }, [careerChartNListData])  // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (onClickChartData) {
            showChartDataPopup();
        }
    }, [onClickChartData])

    useEffect(() => {
        if (params) {
            // setUpskillCareerCoursesSteps([
            //     {
            //         label: 'Career History',
            //         link: `/${params.cg_name}/career-history`
            //     },
            //     {
            //         label: 'Skilldar',
            //         link: `/${params.cg_name}/upskill/skilldar`
            //     },
            //     {
            //         label: 'Career and Upskill time',
            //     },
            // ])
            setUpskillCareerCoursesSteps([
                {
                    label: 'Your Skills',
                    link: isRegion ? `/region/${params.rg_name}/upskill/skilldar` : `/${params.cg_name}/upskill/skilldar`
                },
                {
                    label: 'Your Careers',
                    link: isRegion ? `/region/${params.rg_name}/upskill/career-courses` : `/${params.cg_name}/upskill/career-courses`
                },
                {
                    label: 'Colleges',
                    link: isRegion ? `/region/${params.rg_name}/upskill/colleges` : `/${params.cg_name}/upskill/colleges`
                },
                {
                    label: 'Your Region',
                    link: isRegion ? `/region/${params.rg_name}/upskill/regional-info` : `/${params.cg_name}/upskill/regional-info`
                },
            ])
        }
    }, [params, isRegion])


    const HandleCloseRadarPopup = () => {
        // setChartWidth(527)
        setSkillRadarPopup(false)
    }
    const HandleCloseSkillReportPopup = () => {
        setGetSkillReportPopup(false)
        setTermsAndCondition(false)
        reset({
            firstName: "",
            lastName: "",
            email: "",
        })
    }
    const HandleOpenRadarPopup = () => {
        // setChartWidth(700)
        setSkillRadarPopup(true)
    }
    const postPdf = (pdfUrl) => {
        const { email, firstName, lastName } = getValues()
        const pdfData = {
            // firstName: pdfReportData?.firstName,
            // lastName: pdfReportData?.lastName,
            // email: pdfReportData?.email,
            firstName,
            lastName,
            email,
            collegeId,
            IP,
            pdfB64: pdfUrl,
            callFrom: "career-courses"
        }
        uploadPdf(pdfData)
            .unwrap()
            .then(() => {
                dispatch(setAlert({
                    type: "success",
                    open: true,
                    msg: `Report generated successfully.`
                }))
                reset({
                    firstName: "",
                    lastName: "",
                    email: "",
                })
                setSkillReportDetails(null)
            })
            .catch((error) => dispatch(setAlert({
                open: true,
                msg: error.data?.msg ? `${error.status}, ${error.data.msg}` : 'Something went wrong'
            }))).finally(() => {
                setPdfLoading(false)
                setGetSkillReportPopup(false)
                setTermsAndCondition(false)
                setSkillReportDetails(null)
                reset({
                    firstName: "",
                    lastName: "",
                    email: "",
                })
            })
    }

    // useEffect(()=>{


    // },[watch('firstName'),watch('lastName'),watch('email')])
    const onSubmit = (data) => {
        setPdfLoading(true)
        const body = {
            IP,
            ...data,
            collegeId,
            callFrom: 'career-courses',
            currentCareerIds: careerHistoryId,
            careerGoal: careerGoalId,
            compareCareerIds: compareCareersState
        }
        sendSkillReport(body)
            .unwrap()
            .then((payload) => {
                setSkillReportDetails(payload)
                // exportPDFWithMethod(postPdf)
                dispatch(addSkillReport(payload))
                // setGetSkillReportPopup(false)
                // setTermsAndCondition(false)
                // analytics({
                //     collegeId,
                //     event: 'SKILL_REPORT',
                //     from: getSkillPopupLocation,
                //     // from: openCompareCareersPopup ? 'comparision' : 'career-courses',
                // })
            })
            .catch((error) => {
                dispatch(setAlert({
                    open: true,
                    msg: `${error.status}, ${error.data.msg}`
                }))
            })
    };
    useEffect(() => {
        if (skillReportDetails && skillReportDetails.reportForVisitorName) {
            // dispatch(setAlert({
            //     type:"success",
            //     open: true,
            //     msg: `Report generated successfully.`
            // }))
            setReport(skillReportDetails)
            // setGetSkillReportPopup(false)
            downloadHandler()

        }
    }, [skillReportDetails]) // eslint-disable-line react-hooks/exhaustive-deps


    const addToAnalytics = ({ event, course }) => {
        analytics({
            collegeId,
            event,
            data: {
                selectedCourseId: course
            },
            from: 'Career Result',
            // from: 'career-courses',
        })
    }

    const redirectUrl = (data, type) => {
        let renderLink = ''
        if (data && data.length > 0) {
            const httpCheck = data.toLocaleLowerCase().startsWith("http")
            if (httpCheck) {
                renderLink = data
            } else {
                renderLink = `http://${data}`
            }
        }
        return (
            <a href={renderLink} rel="noreferrer" target='_blank'> <Typography variant='medium' color="white" sx={{ textTransform: 'none', display: 'flex', alignItems: 'center', fontSize: '1.05rem' }} >{type}<KeyboardArrowRightIcon sx={{ color: 'white' }} /></Typography></a>
        )
    }

    const showComparePopup = (id) => {

        // if(compareCareersState.find(currentCareer => currentCareer === id)){
        HandleCloseCareerDetailsPopup()
        setShowCompare(true)
        // }else{
        //     addToCompare(id)
        //     HandleCloseCareerDetailsPopup()
        //     setShowCompare(true) 
        // }
    }

    useEffect(() => {
        if (showCompare) {
            showCompareCareersPopup()
        }
    }, [showCompare, compareCareersState])  // eslint-disable-line react-hooks/exhaustive-deps
    // console.log(rg_name)
    const regions = useSelector((state) => state.careerHistory);
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (rg_name) {
            Cookies.set('url-slug', rg_name);
        }
    }, [rg_name])

    useEffect(() => {
        setLoading(true)
        dispatch(getRegionBySlug(rg_name))
    }, [rg_name, dispatch])

    useEffect(() => {
        if ((regions?.regions)) {
            setData(regions?.regions)
            if (!isEmpty(data)) {
                setLoading(false)
            }
        }
    }, [regions?.regions, data])
    const buttonColor = data?.button?.bgColor;
    const buttonFontColor = data?.button?.color;
    const logo = data?.logo || '';
    const partnerLogos = data?.partnerLogos || [];
    const primaryColor = data?.primaryColor || '';
    const fontColor = data?.fontColor || '';
    const secondaryColor = data?.secondaryColor || '';
    const bgImage = data?.bgImage || '';
    const handleToggle = (event) => {
        setIsReskill(event.target.checked);
    };

    const steps = [
        { icon: <AssignmentIcon />, label: 'Career History' },
        { icon: <ArcticonsEmojiSpiderWeb width={36} height={36} color={buttonFontColor} />, label: 'Results' }  // Capitalized if it's a component
    ];
    return (
        <>
            <Helmet>
                <title>Upskill - Careers & Courses</title>
            </Helmet>

            <Box
                sx={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    minHeight: '100vh',
                    backgroundAttachment: 'fixed'
                }}
                className='page-content-wrapper'
            >
                {/* <Box > */}
                <Container maxWidth='xl'>
                    <Box ref={scrollRef} className='content'>
                        <ThinkSkillsHeader fontColor='white' />
                        <Box pb={2}>
                            <RegionStepper steps={steps}
                                activeStep={1} // Change to 1 to highlight "Results"
                                buttonColor={buttonColor}
                                buttonFontColor={buttonFontColor} />
                        </Box>
                        <SecondRegionStepper steps={UpskillCareerCoursesSteps} activeStep={1} noIcon />
                        <GraphsData
                            showCompareCareersPopup={showCompareCareersPopup}
                            careersUpskillTime={careersUpskillTime}
                            addToCompare={addToCompare}
                            status={status}
                            isLoading={status?.isLoading || regionStatus?.isLoading}
                            compareCareersState={compareCareersState}
                            showCareerDetailsPopup={HandleOpenCareerDetailsPopup}
                            careerHistoryId={careerHistoryId}
                            careerGoalId={careerGoalId}
                            getSkillReport={getSkillsReport}
                            scrollRef={scrollRef}
                            collegeId={collegeId}
                            IP={IP}
                            handleToggle={handleToggle}
                            isReskill={isReskill}
                            isRegion={isRegion}
                            regionData={data}
                        />

                        <DekstopPoup
                            careerNCoursesPopDetails={careerNCoursesPopDetails}
                            openCareerDetailsPopup={openCareerDetailsPopup}
                            HandleCloseCareerDetailsPopup={HandleCloseCareerDetailsPopup}
                            showComparePopup={showComparePopup}
                            addToCompare={addToCompare}
                            compareCareersState={compareCareersState}
                            getSkillsReport={getSkillsReport}
                            addToAnalytics={addToAnalytics}
                            redirectUrl={redirectUrl}
                            currentNGoalCareerId={currentNGoalCareerId}
                            expanded={expanded}
                            readMore={readMore}
                            setReadMore={setReadMore}
                            ref={ref}
                            HandleOpenRadarPopup={HandleOpenRadarPopup}
                            regionalChartData={regionalChartData}
                            qualificationsChartData={qualificationsChartData}
                            handleChange={handleChange}
                        />
                        <MobilePopup
                            careerNCoursesPopDetails={careerNCoursesPopDetails}
                            openCareerDetailsPopup={openCareerDetailsPopup}
                            HandleCloseCareerDetailsPopup={HandleCloseCareerDetailsPopup}
                            showComparePopup={showComparePopup}
                            addToCompare={addToCompare}
                            compareCareersState={compareCareersState}
                            getSkillsReport={getSkillsReport}
                            addToAnalytics={addToAnalytics}
                            redirectUrl={redirectUrl}
                            currentNGoalCareerId={currentNGoalCareerId}
                            expanded={expanded}
                            readMore={readMore}
                            setReadMore={setReadMore}
                            ref={ref}
                            HandleOpenRadarPopup={HandleOpenRadarPopup}
                            regionalChartData={regionalChartData}
                            qualificationsChartData={qualificationsChartData}
                            handleChange={handleChange}
                        />

                        <CompareCareerComponent
                            openPopup={openCompareCareersPopup}
                            HandleClosePopup={HandleCloseCompareCareersPopup}
                            downloadHandler={downloadHandler}
                            showCareerDetailsPopup={HandleOpenCareerDetailsPopup}
                            removeFromComparison={removeFromComparison}
                            getSkillsReport={getSkillsReport}
                            compareCareersData={compareCareersData}
                            setCompareCareersData={setCompareCareersData}
                        />
                        <Popover
                            open={skillRadarPopup}
                            onClose={HandleCloseRadarPopup}
                            className='chart-popup'
                        >
                            <Button className='close-btn' onClick={HandleCloseRadarPopup}><CloseIcon /></Button>

                            <Box className="col" >
                                <Typography variant='h4' className='heading' color='primary.dark'>Skilldar</Typography>
                                <Grid container className='popup-chart-wrapper'>
                                    <Grid item lg={3} >
                                        <Box className='skilldar-keys' >
                                            <Box sx={{ width: '100%' }}>
                                                <Typography className='title' variant='capitalize' textAlign='left' color={darkBlue} sx={{ marginBottom: '8px' }}>Skill Level</Typography>
                                                {
                                                    skillLevels.map((skill) => (
                                                        <Typography key={skill.title} sx={{ marginBottom: '0px !important' }} className='skill-level' color={darkBlue}><span className='line' style={{ borderColor: skill.color, width: '15%', display: 'inline-block' }} />{skill.title}</Typography>
                                                    ))
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item lg={9} ref={popupRef}>
                                        <RadarChartComponent
                                            width={popupChartWidth || 500}
                                            legend
                                            radarApiDetails={careerNCoursesPopDetails?.skilldarChartData}
                                            height='100%'
                                            careersDetails='true'
                                            showlabels
                                            disableTooltip
                                            chartAnimation
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Popover>

                        <Popover
                            open={getSkillReportPopup}
                            onClose={HandleCloseSkillReportPopup}
                            className='app-popup skilldar getskill-report'
                        >
                            <Button className='close-btn' onClick={HandleCloseSkillReportPopup}><CloseIcon sx={{ color: 'primary.dark', fontWeight: '900' }} /></Button>
                            <Box className="col">
                                <Typography variant='h4' color='primary.dark' sx={{ fontWeight: 700, fontSize: '25px !important', textAlign: 'left' }} >Get Skills Report</Typography>

                                <Box className='flex' sx={{ justifyContent: "center", pt: 2 }}>
                                    <Typography variant='body1' color='primary.dark' sx={{ textAlign: "left", pb: 3, fontWeight: '600' }}>Get a copy of your unique Skilldar to keep, and a summary of any careers and associated courses you have saved to your comparison.  We will also send this information to the college so they can help you find the perfect course for your needs.</Typography>
                                </Box>
                                <Box>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Grid container spacing={2} pr={4}>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    // label="First Name"
                                                    name="firstName"
                                                    type='text'
                                                    placeholder="First Name"
                                                    variant="outlined"
                                                    {...register('firstName')}
                                                    focused='true'
                                                    sx={{
                                                        width: "100%",
                                                        "& input::placeholder": { fontSize: "18px", color: 'primary.dark', fontWeight: '500' },
                                                        "& .MuiOutlinedInput-root": {
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "primary.dark"
                                                            }
                                                        }
                                                    }}
                                                    inputProps={{ style: { fontSize: 18 } }}
                                                    helperText={errors.firstName && errors.firstName.message}
                                                    error={errors.firstName && errors.firstName.message}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    // label="Last Name"
                                                    name="lastName"
                                                    type='text'
                                                    placeholder="Last Name"
                                                    variant="outlined"
                                                    {...register('lastName')}
                                                    focused='true'
                                                    sx={{
                                                        width: "100%",
                                                        "& input::placeholder": { fontSize: "18px", fontWeight: '500', color: 'primary.dark' },
                                                        "& .MuiOutlinedInput-root": {
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "primary.dark"
                                                            }
                                                        }
                                                    }}
                                                    inputProps={{ style: { fontSize: 18 } }}
                                                    helperText={errors.lastName && errors.lastName.message}
                                                    error={errors.lastName && errors.lastName.message}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    // label="Email"
                                                    name="email"
                                                    type='text'
                                                    placeholder="Email Address"
                                                    variant="outlined"
                                                    {...register('email')}
                                                    focused='true'
                                                    sx={{
                                                        width: "100%",
                                                        "& input::placeholder": { fontSize: "18px", fontWeight: '500', color: 'primary.dark' },
                                                        "& .MuiOutlinedInput-root": {
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "primary.dark"
                                                            }
                                                        }
                                                    }}
                                                    inputProps={{ style: { fontSize: 18 } }}
                                                    helperText={errors.email && errors.email.message}
                                                    error={errors.email && errors.email.message}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='tc-checkbox-wrapper'>
                                                <Checkbox onClick={(e) => { setTermsAndCondition(e.target.checked) }} sx={{ color: 'primary.dark', transform: "scale(1.5)", mr: 1 }} />

                                                <Typography sx={{ color: 'primary.dark', display: 'inline', fontWeight: '600' }} >I accept the
                                                    <Link target='_blank' rel="noreferrer" to='/terms-conditions'>terms and conditions</Link>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <LoadingButton
                                            loading={pdfLoading}
                                            disabled={!termsAndCondition}
                                            endIcon={<KeyboardArrowRightOutlinedIcon sx={{ fontSize: '30px !important' }} />}
                                            variant='contained'
                                            sx={{ minWidth: "15%", mt: 1, bgcolor: 'secondary.main', fontWeight: '600', padding: '10px', borderRadius: '6px' }} type='submit'>SUBMIT</LoadingButton>
                                    </form>
                                </Box>
                            </Box>
                        </Popover>

                        <Box sx={{ height: '0px', overflow: 'hidden', width: '0px' }}>
                            <PDFExport
                                ref={reportRef}
                                paperSize='A4'
                                fileName='Report'>
                                <Report roleType='upskill' />
                            </PDFExport>
                        </Box>

                    </Box>
                </Container>
            </Box>
        </>
    )
}